import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { LiveDirectWatchTemplate } from "~/features/live/LiveDirectWatchTemplate";

// sid: ログインに使うトークン（無ければいまのログインのまま） / uid: 視聴する配信者の user_id
const watchSearchSchema = z.object({
  sid: z.string().min(1).optional().catch(undefined),
  uid: z.string().min(1).optional().catch(undefined),
});

const LiveDirectWatchPage = () => {
  const { sid, uid } = Route.useSearch();
  return <LiveDirectWatchTemplate sid={sid} uid={uid} />;
};

// トークンを URL で受け取ってその場でログインできるよう、_authenticated の外に置く
export const Route = createFileRoute("/watch/")({
  validateSearch: watchSearchSchema,
  component: LiveDirectWatchPage,
});
